import { useQuery } from '@tanstack/react-query';
import { DealService } from '@spilca/order_ts/v1/order_web/deal_web_pb_service';
import {
  GetDealContactRequest,
  GetDealContactResponse
} from '@spilca/order_ts/v1/order/model_deal_pb';
import { getGrpcPromise, TGRPCPromiseReject } from '@monorepo/grpc';
import { QUERY_KEYS } from '@monorepo/helpers';

const useGetContact = (id: string) => {
  const request = new GetDealContactRequest();
  if (id) {
    request.setId(id);
  }

  const requestPromise = (): Promise<GetDealContactResponse.AsObject> =>
    getGrpcPromise(DealService.GetDealContact)(request);

  return useQuery<GetDealContactResponse.AsObject, TGRPCPromiseReject>({
    queryKey: [QUERY_KEYS.GET_CONTACT, id],
    queryFn: requestPromise,
    gcTime: 300000,
    staleTime: Infinity,
    refetchOnWindowFocus: false
  });
};

export default useGetContact;
